import {
  type OpeningConfigDB,
  type OpeningConfigLine,
  type OpeningConfigValidationResponse,
  type OpeningMode,
  type PendingOpeningEventWithContext,
} from '@gozoki/api-types'
import { gozokiApiWithAuth } from '../gozokiApi'

const defaultDoorConfig: OpeningConfigDB = {
  1: [
    {
      beginTime: '00:00',
      openingMode: 'UNATTENDED',
    },
  ],
  2: [
    {
      beginTime: '00:00',
      openingMode: 'UNATTENDED',
    },
  ],
  3: [
    {
      beginTime: '00:00',
      openingMode: 'UNATTENDED',
    },
  ],
  4: [
    {
      beginTime: '00:00',
      openingMode: 'UNATTENDED',
    },
  ],
  5: [
    {
      beginTime: '00:00',
      openingMode: 'UNATTENDED',
    },
  ],
  6: [
    {
      beginTime: '00:00',
      openingMode: 'UNATTENDED',
    },
  ],
  7: [
    {
      beginTime: '00:00',
      openingMode: 'UNATTENDED',
    },
  ],
}

export const fetchConfigDoor = async (storeId: number) => {
  const response = await gozokiApiWithAuth.get<OpeningConfigDB | null>(
    `/stores/${storeId}/open/config`,
  )
  return response.data ?? defaultDoorConfig
}

export const updateConfigDoor = async (
  storeId: number,
  body: Record<number, OpeningConfigLine[]>,
) => {
  const response = await gozokiApiWithAuth.post<OpeningConfigValidationResponse>(
    `/stores/${storeId}/open/config`,
    body,
  )
  return response.data
}

export const openDoor = async (kioskId: number, granted: boolean) => {
  const response = await gozokiApiWithAuth.post(`/kiosk/${kioskId}/open-client`, { granted })
  return response.data
}

export const fetchStoreOpeningState = async (storeId: number) => {
  const response = await gozokiApiWithAuth.get<{
    success: boolean
    openingMode: OpeningMode | null
    error: string | null
  }>(`/stores/${storeId}/open/state`)
  return response.data
}

export const fetchAllPendingOpeningEvents = async (storeIds?: number[]) => {
  const response = await gozokiApiWithAuth.get<PendingOpeningEventWithContext[]>(
    '/opening/pending-events',
    {
      params: storeIds && storeIds.length > 0 ? { storeIds: storeIds.join(',') } : undefined,
    },
  )
  return response.data
}

export const triggerDoorConfiguration = async () => {
  const response = await gozokiApiWithAuth.post<{
    success: boolean
    message: string
    timestamp: string
  }>('/cron/door-configuration')
  return response.data
}
